import React from "react";
import { ImgComparisonSlider } from "@img-comparison-slider/react";
import "./styles.scss";

const FallInHome = (props) => {
  const { image1, image2, description, title } = props;

  return (
    <div className="fallIn-home-container">
      <h3 dangerouslySetInnerHTML={{ __html: title }} />
      <div
        className="description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
      <div className="image-slider">
        <ImgComparisonSlider style={{ width: "100%" }}>
          <figure slot="first" class="before">
            <img
              slot="first"
              src={image1}
              alt="slot1"
              height="580"
              width="100%"
            />
            <figcaption>Before</figcaption>
          </figure>
          <figure slot="second" class="after">
            <img
              slot="second"
              src={image2}
              alt="slot2"
              height="580"
              width="100%"
            />
            <figcaption>After</figcaption>
          </figure>

          <svg
            slot="handle"
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            viewBox="-8 -3 16 6"
          >
            <path
              stroke="#d25333"
              d="M -5 -2 L -7 0 L -5 2 M -5 -2 L -5 2 M 5 -2 L 7 0 L 5 2 M 5 -2 L 5 2"
              stroke-width="1"
              fill="#d25333"
              vector-effect="non-scaling-stroke"
            ></path>
          </svg>
        </ImgComparisonSlider>
      </div>
    </div>
  );
};

export default FallInHome;
